export default __webpack_public_path__ + "static/media/co_present_black_24dp.9d3abe87.svg";